// extracted by mini-css-extract-plugin
export var closeButton = "_2s-3";
export var header = "_2s-0";
export var link = "_2s-1";
export var retryButton = "_2s-2";